import { render, staticRenderFns } from "./myAssetsList.vue?vue&type=template&id=4e846304&scoped=true"
import script from "./myAssetsList.vue?vue&type=script&lang=js"
export * from "./myAssetsList.vue?vue&type=script&lang=js"
import style0 from "./myAssetsList.vue?vue&type=style&index=0&id=4e846304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e846304",
  null
  
)

export default component.exports